<script setup lang="ts">
import { modalAlertClass, type AlertTone } from '@/models/current-student-advanced-standing-form/modalAlert'

defineProps<{
  alertId: string
  alertTone: AlertTone
  message: string
}>()
</script>

<template>
  <div class="alert" :id="alertId" :class="modalAlertClass(alertTone)">{{ message }}</div>
</template>
